module.exports = __webpack_public_path__ + "img/takeoff.bca4e583.jpg";